import React from 'react';
import styled from 'styled-components';
import { SanityBlockContent } from './SanityBlockContent';

const StyledHeader = styled.div`
  span {
    color: ${(props) => props.$spanColor};
  }
  h2 {
    color: ${(props) => props.$h2Color};
  }
`;

const SectionHeader = ({
  sanity,
  page,
  tagline,
  headline,
  description,
  classes = '',
  h2Classes = '',
}) => {
  const { colors } = sanity;
  return (
    <StyledHeader
      $h2Color={colors?.neutral?.darker}
      $spanColor={colors?.accent?.dark}
      className={`mb-24 text-center ${classes}`}
    >
      {tagline && (
        <span className="text-base font-semibold tracking-wider uppercase">
          {tagline}
        </span>
      )}
      {headline && (
        <h2
          className={`mx-auto mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl lg:max-w-2xl ${h2Classes}`}
        >
          {headline}
        </h2>
      )}
      {description && (
        <div className="mx-auto mt-5 text-xl max-w-prose text-zinc-600">
          <SanityBlockContent
            sanity={sanity}
            page={page}
            blocks={description}
          />
        </div>
      )}
    </StyledHeader>
  );
};

SectionHeader.displayName = 'SectionHeader';

export { SectionHeader };
